// extracted by mini-css-extract-plugin
export default {"wrapper":"Code_wrapper__tmvcg"};